import { z } from 'zod'

const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1),
  VITE_API_URL: z.string().url(),
  VITE_APP_URL: z.string().url().optional(),
})

const parsed = envSchema.safeParse(import.meta.env)

if (!parsed.success) {

  console.error('Invalid frontend env:', parsed.error.flatten().fieldErrors)
  throw new Error('Frontend environment ungueltig — siehe Konsole.')
}

export const env = parsed.data
